module.exports = __webpack_public_path__ + "static/media/accordion_down_icon.4e6887ba.svg";